// Chart modes several question types share by name. The word cloud's is also the value the report
// stores in a question's `cm` param while the block shows its cloud instead of a chart.

export const WC_CHART_MODE = 'wc'

// The modes that draw shares rather than counts.
export const PERCENT_CHART_MODES = ['percents', 'bpercents']

export const isWcChartMode = chartMode => WC_CHART_MODE === chartMode
